import styled from 'styled-components';
import { Space } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';

export const CustomSpace = styled(Space)`
  .ant-space-item:first-child {
    flex: 1;
    width: 100%;
  }

  .ant-space-item:first-child .ant-input {
    width: 100%;
  }
`;

export const StyledMinusIcon = styled(MinusCircleOutlined)`
  color: ${props => (props.theme.title === 'dark' ? '#fff' : '#000')};
`;
